import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {Master} from '../../../../../admin/models/master.interface';
import {FormBuilder, FormControl} from '@angular/forms';
import {ChartsSearchInterface} from '../../../../models/charts-search.interface';
import {setFormValuesFromQueryParams} from '../../../../utils/filters-utils';
import {ActivatedRoute} from '@angular/router';
import {MatOption} from '@angular/material/core';

@Component({
  selector: 'app-cost-benchmark-filters',
  templateUrl: './cost-benchmark-filters.component.html',
  styleUrls: ['./cost-benchmark-filters.component.scss']
})
export class CostBenchmarkFiltersComponent implements OnInit, OnChanges {

  @ViewChild('allSelected') private allSelected!: MatOption;
  @ViewChild('allCategorySelected') private allCategorySelected!: MatOption;

  @Input()
  years!: number[];
  @Input()
  collectionStreams!: Master[];
  @Input()
  type!: string;

  searchForm = this.formBuilder.group({
    year: [''],
    collectionStreams: [''],
    detailLevel: [],
    b2bB2c: [],
    member: [],
    costCategories: [''],
  });

  get yearControl(): FormControl {
    return this.searchForm.get('year') as FormControl;
  }
  get collectionStreamsControl(): FormControl {
    return this.searchForm.get('collectionStreams') as FormControl;
  }
  get detailLevelControl(): FormControl {
    return this.searchForm.get('detailLevel') as FormControl;
  }
  get b2bB2cControl(): FormControl {
    return this.searchForm.get('b2bB2c') as FormControl;
  }
  get costCategoriesControl(): FormControl {
    return this.searchForm.get('costCategories') as FormControl;
  }
  get memberControl(): FormControl {
    return this.searchForm.get('member') as FormControl;
  }

  @Output()
  search: EventEmitter<ChartsSearchInterface> = new EventEmitter<ChartsSearchInterface>();

  constructor(private formBuilder: FormBuilder, private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.yearControl.setValue(this.years[0]);
    setFormValuesFromQueryParams(this.searchForm, this.activatedRoute);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.collectionStreams?.length) {
      if (!this.collectionStreamsControl.value || this.collectionStreamsControl.value.length === this.collectionStreams.length) {
        if (this.allSelected) {
          this.allSelected.select();
        }
        this.collectionStreamsControl
          .patchValue([...this.collectionStreams.map(item => item.id.toString()), 0]);
      }

      if (!this.costCategoriesControl.value || this.costCategoriesControl.value.length === (this.type === 'Operational' ? 3 : 5)) {
        if (this.allCategorySelected) {
          this.allCategorySelected.select();
        }
        
        this.costCategoriesControl
          .patchValue(this.type === 'Operational' ? ['COLLECTION', 'LOGISTICS', 'TREATMENT', 0] : ['CLEARING_HOUSE', 'COMMUNICATION', 'RD', 'OFFICE', 'OTHER', 0]);
        
      }
    }
  }

  handleSubmit(): void {
    const search: ChartsSearchInterface = {
      startYear: this.yearControl.value,
      categories: this.collectionStreamsControl.value,
      detailLevel: this.detailLevelControl.value,
      b2bB2c: this.b2bB2cControl.value,
      member: this.memberControl.value,
      costCategories: this.costCategoriesControl.value
    };
    if (search.costCategories && search.costCategories instanceof Array) {
      search.costCategories = search.costCategories?.filter(item => item.toString() !== '0');
    }
    this.search.emit(search);
    if (this.collectionStreamsControl.value.length === this.collectionStreams.length) {
      this.allSelected.select();
    }
  }

  clean(): void {
    this.yearControl.setValue(this.years[this.years.length - 1]);
    this.collectionStreamsControl.reset();
    this.detailLevelControl.reset();
    this.b2bB2cControl.reset();
    this.costCategoriesControl.reset();
    this.memberControl.reset();
    this.search.emit({startYear: this.years[0], displayUnits: 'AVERAGE'});
  }

  togglePerOne(): void {
    if (this.allSelected.selected) {
      this.allSelected.deselect();
      return;
    }
    if (this.collectionStreamsControl.value.length === this.collectionStreams.length) {
      this.allSelected.select();
    }
  }

  toggleAllSelection(): void {
    if (this.allSelected.selected) {
      this.collectionStreamsControl
        .patchValue([...this.collectionStreams.map(item => item.id.toString()), 0]);
    } else {
      this.collectionStreamsControl.patchValue([]);
    }
  }

  togglePerOneCategory(): void {
    if (this.allCategorySelected.selected) {
      this.allCategorySelected.deselect();
      return;
    }
    if (this.costCategoriesControl.value.length === (this.type === 'Operational' ? 3 : 5)) {
      this.allCategorySelected.select();
    }
  }

  toggleAllSelectionCategory(): void {
    if (this.allCategorySelected.selected) {
      this.costCategoriesControl
        .patchValue(this.type === 'Operational' ? ['COLLECTION', 'LOGISTICS', 'TREATMENT', 0] : ['CLEARING_HOUSE', 'COMMUNICATION', 'RD', 'OFFICE', 'OTHER', 0]);
    } else {
      this.costCategoriesControl.patchValue([]);
    }
  }

}
